import type { EventBusKey } from '@vueuse/core';

export const utilitiesKey: EventBusKey<string> = Symbol('utilities');
